import React from "react";
import DialogWrapper from "./DialogWrapper";

export default function DeleteConfirmation({
  deleteModule,
  open,
  cancelAction,
}) {
  return (
    <DialogWrapper
      title={"Delete Model"}
      cancelLabel="Cancel"
      actionLabel={"Delete Model"}
      actionRed
      small
      open={open}
      acceptButton={() => {
        deleteModule();
      }}
      cancelAction={cancelAction}
      onClose={() => {
        cancelAction();
      }}
    >
      Do you really want to delete this model permenanetly. This process cannot
      be undone.
    </DialogWrapper>
  );
}
